var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrev = function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#9BA0A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.333 16 4-3.464v6.928l-4-3.464Z",
    fill: "#9BA0A5"
  })));
};
export { SvgPrev as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTUuNSIgc3Ryb2tlPSIjOUJBMEE1Ii8+CjxwYXRoIGQ9Ik0xMy4zMzMgMTZMMTcuMzMzIDEyLjUzNTlMMTcuMzMzIDE5LjQ2NDFMMTMuMzMzIDE2WiIgZmlsbD0iIzlCQTBBNSIvPgo8L3N2Zz4K";